import { useInvalidateOrders } from '@/entities/order';
import { useInvalidateTaxInvoice } from '@/entities/tax-invoice';
import { trpc } from '@/shared/api';

export const useReissueTaxInvoice = () => {
  const mutation = trpc.taxInvoiceManagement.reissue.useMutation();
  const invalidateInvoice = useInvalidateTaxInvoice();
  const orders = useInvalidateOrders();
  return async (orderId: string) => {
    await mutation.mutateAsync({ orderId });
    await Promise.all([invalidateInvoice(orderId), orders.detail(orderId)]);
  };
};
